<template>
    <div class="content">
        <h3 class="mt-2 mb-5 ml-2 is-hidden-desktop"><i class="fal fa-address-book fa-fw mr-3"></i>Trip Contacts</h3>

        <!-- Free-form trip-level admin/office contacts, shown above the participant roster. -->
        <div class="white-container content ql-editor" v-if="trip.app_contacts" v-html="trip.app_contacts"></div>

        <!-- Auto-compiled full contact list pulled from every trip record (staff only).
             Unlike the Travelers roster, this ignores the travelers' profile share flags. -->
        <div class="mt-5" v-if="loading">
            <h5 class="has-text-grey"><i class="fal fa-tennis-ball fa-spin mr-3"></i>Gathering contacts from the trip records...</h5>
        </div>
        <div class="mt-5" v-else-if="contacts.length">
            <h5 class="ml-2 mb-4"><i class="far fa-address-book fa-fw mr-2"></i>Participants</h5>
            <div class="white-container">
                <div class="contact-card" v-for="c in contacts" :key="c.id">
                    <div class="contact-name">
                        {{ c.last_name }}, {{ c.first_name }}<template v-if="c.middle_name"> {{ c.middle_name }}</template><template v-if="c.preferred_name"> &ldquo;{{ c.preferred_name }}&rdquo;</template>
                        <span class="contact-role" v-if="c.role"> &middot; {{ c.role }}</span>
                    </div>
                    <div class="contact-line" v-if="c.email"><i class="far fa-envelope fa-fw mr-2"></i><a :href="'mailto:' + c.email">{{ c.email }}</a></div>
                    <div class="contact-line" v-if="c.phone"><i class="far fa-phone fa-fw mr-2"></i><a :href="'tel:' + telLink(c.phone)">{{ telLink(c.phone) }}</a></div>
                    <div class="contact-line" v-if="c.phone_2"><i class="far fa-phone fa-fw mr-2"></i><a :href="'tel:' + telLink(c.phone_2)">{{ telLink(c.phone_2) }}</a></div>
                    <div class="contact-line" v-if="fullAddress(c)"><i class="far fa-location-dot fa-fw mr-2"></i>{{ fullAddress(c) }}</div>
                    <div class="contact-line" v-if="c.instagram"><i class="fab fa-instagram fa-fw mr-2"></i>{{ c.instagram }}</div>
                    <div class="contact-line" v-if="c.facebook"><i class="fab fa-facebook-f fa-fw mr-2"></i>{{ c.facebook }}</div>
                    <div class="contact-line" v-if="c.twitter"><i class="fab fa-twitter fa-fw mr-2"></i>{{ c.twitter }}</div>
                    <div class="contact-line" v-if="c.whatsapp"><i class="fab fa-whatsapp fa-fw mr-2"></i>{{ c.whatsapp }}</div>
                </div>
            </div>
        </div>

        <!-- Nothing at all yet -->
        <div class="white-container content has-text-centered" v-if="!loading && !contacts.length && !trip.app_contacts">
            <h4 class="pt-6 pb-6 has-text-grey"><i class="fal fa-message-captions mr-2"></i> More information will be available later.  Check back soon!</h4>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {client as http} from "../../http_client";

    export default {
        data: function() {
            return {
                loading: false,
                contacts: []
            };
        },
        computed: {
            ...mapGetters(['trip', 'registration']),
            isStaff: function() {
                return this.registration.type === 'staff' || this.registration.second_type === 'staff';
            }
        },
        methods: {
            // Phone numbers are now stored normalized with a leading "+". Collapse any
            // number of leading "+" into exactly one so we never render "++1650...".
            telLink: function(p) {
                if (!p) return '';
                return '+' + String(p).replace(/^\++/, '');
            },
            fullAddress: function(c) {
                const cityLine = [c.city, c.state].filter(Boolean).join(', ');
                return [c.address, c.address_2, [cityLine, c.zip].filter(Boolean).join(' '), c.country]
                    .filter(Boolean).join(', ').trim();
            },
            loadContacts: function() {
                if (!this.registration.id || !this.isStaff) return;
                this.loading = true;
                http.get('/app/trips/' + this.registration.trip_id + '/staff/contacts').then(response => {
                    this.contacts = response.data || [];
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            }
        },
        watch: {
            registration: function() {
                this.loadContacts();
            }
        },
        mounted() {
            this.loadContacts();
        }
    };
</script>

<style lang="scss" scoped>
    .contact-card {
        border-left: 3px solid #628b21;
        padding-left: 0.7rem;
        padding-bottom: 0.9rem;
        margin-bottom: 0.9rem;
        border-bottom: 1px solid #ededed;

        &:last-child {
            padding-bottom: 0;
            margin-bottom: 0;
            border-bottom: 0;
        }

        .contact-name {
            font-weight: 700;
            margin-bottom: 0.3rem;
        }

        .contact-role {
            font-weight: 400;
            color: #6b6b6b;
            font-size: 0.85rem;
            text-transform: capitalize;
        }

        .contact-line {
            font-size: 0.95rem;
            margin-bottom: 0.15rem;
        }
    }
</style>
